const getCookie = (key: string) => {
  if (typeof key !== "string" || key.length < 1) return false;
  const { cookie } = document;
  if (typeof cookie !== "string" || cookie.length < 3) return false;
  const entry = cookie.split("; ").find((cookie) => cookie.includes(key));
  if (!entry) return false;
  return entry.split("=")[1];
};

export default getCookie;
